import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { AnalyticsService } from '@app/core/services/analytics.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AppService } from 'src/app/core/services/app.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    imports: [AsyncPipe, TranslateModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class SettingsComponent implements OnInit {
  readonly translate = inject(TranslateService);
  private readonly appService = inject(AppService);
  private readonly router = inject(Router);
  private readonly analyticsService = inject(AnalyticsService);

  public readonly textSizes = ['small', 'medium', 'large'];
  public textSize$ = this.appService.textSize$;
  public downloadContent$ = this.appService.downloadContent$;

  ngOnInit(): void {
    this.analyticsService.setDocumentTitleWithExhibitionTitle('Einstellungen');
  }

  onClickTextSize(textSize: string) {
    this.appService.setTextSize(textSize);
  }

  onChangeDownloadContent(event: MatSlideToggleChange) {
    if (event.checked) {
      this.router.navigate([ '/' ]);
      setTimeout(() => location.reload(), 400);
    }
    this.appService.setDownloadContent(event.checked);
  }

}
